import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
import kvWorking from "@/components/kiva/static/kvWorking";
import sidebarDashboard from "@/components/dashboard/sidebar";
import megaMenuComp from "@/layout/components/Sidebar/megaMenu";
import helpButton from "@/layout/components/Sidebar/helpButton";
import SvgIcon from '@/components/kiva/kvSvgIcon.vue';
export default {
  name: "SidebarItem",
  components: {
    Item: Item,
    AppLink: AppLink,
    sidebarDashboard: sidebarDashboard,
    megaMenuComp: megaMenuComp,
    SvgIcon: SvgIcon
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    return {
      megaMenu: false
    };
  },
  created: function created() {
    this.onlyOneChild = null;
  },
  computed: {
    unreadNotification: function unreadNotification() {
      return this.$store.state.notification.unreadNotification;
    },
    noUnreadSuccess: function noUnreadSuccess() {
      return this.$store.state.notification.noUnreadSuccess;
    }
  },
  filters: {
    max3chars: function max3chars(value) {
      if (value > 99) return "+99";
      return value;
    }
  },
  methods: {
    mouseEnter: function mouseEnter() {
      // console.log("mouseEnter");
      this.megaMenu = true;
    },
    mouseLeave: function mouseLeave() {
      // console.log("mouseEnter");

      this.megaMenu = false;
    },
    hasOneShowingChild: function hasOneShowingChild() {
      var _this = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: "",
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      if (path.resolve(this.basePath, routePath)) {
        return path.resolve(this.basePath, routePath);
      } else {
        return '/';
      }
    }
  }
};